export enum BANRnoEnum {
    'ABN AMRO' = 49,
    'ABSA' = 20,
    'Access Bank' = 27,
    'African' = 18,
    'Albaraka' = 58,
    'Allied' = 1,
    'Bank Atlántico' = 67,
    'Bank of Namibia' = 69,
    'Bank Of Taiwan' = 37,
    'Bank Of Transkei' = 29,
    'Bank Of Windhoek' = 64,
    'Bank Windhoek' = 30,
    'BankBIC' = 68,
    'BarclaysSwazi' = 50,
    'Bidvest' = 57,
    'Board Of Executors' = 42,
    'Boland' = 10,
    'Cape Of Good Hope' = 22,
    'Capitec Bank' = 53,
    'Citibank' = 24,
    'Commercial Bank Of Namibi' = 21,
    'Community' = 33,
    'Credit Agricole Indosuez' = 26,
    'DICOVERY UNIVERSAL BRANC' = 77,
    'ECOBank' = 59,
    'Fidelity' = 38,
    'FinBond' = 60,
    'FINBOND NET1' = 78,
    'First Corp' = 43,
    'Firstdata' = 61,
    'FNB' = 5,
    'FNB Namibia' = 65,
    'Future Bank Corp LTD' = 25,
    'Grindrod' = 56,
    'Habib Overseas' = 35,
    'HBZ' = 31,
    'Investec' = 32,
    'Ithala' = 19,
    'J.P.MORGAN CHASE BANK N.A' = 75,
    'Lesotho' = 36,
    'Letshego Bank Namibia' = 70,
    'MEEG' = 41,
    'Mercantile Of Lisbon' = 17,
    'MTN (Standard)' = 55,
    'NBS' = 9,
    'Nedbank' = 7,
    'Nedbank Namibia' = 71,
    'None' = 15,
    'Other' = 14,
    'Peoples' = 11,
    'PEP Bank' = 48,
    'Perm' = 8,
    'Permanent' = 23,
    'Post Office' = 51,
    'Rennies Bank' = 54,
    'Reserve' = 40,
    'Saambou' = 12,
    'SASFIN' = 62,
    'Stanbic Lesotho' = 47,
    'Standard' = 6,
    'Standard Bank Namibia' = 72,
    'Standard Chartered' = 44,
    'Standard Swaziland' = 46,
    'SWABOU' = 34,
    'Teba' = 52,
    'Trust' = 3,
    'TrustCo Bank' = 66,
    'TYME ROSEBANK' = 76,
    'Unibank' = 39,
    'Unibank Limited' = 45,
    'United' = 2,
    'Unknown' = 16,
    'VBS' = 63,
    'Volks' = 13,
    'Volkskas' = 4
}

export namespace BANRnoEnum {
    export function values() {
        return Object.keys(BANRnoEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
